import getLastReadMessageId from '../../helpers/getLastReadMessageId';
import { setChatHistoryLastReadMessage } from '../../helpers/updateChatHistoryLastReadMessage.helpers';

export default (state, action, config) => {
  const currentResource =
    state[config.propName][action.payload.resourceId] || {};
  const currentResourceChats = currentResource.chats || {};
  const currentChat = currentResourceChats[action.payload.chatId] || {};
  const currentHistory = currentChat.history || [];
  const lastReadMessage = currentHistory.length
    ? currentHistory[currentHistory.length - 1]
    : {};

  const lastReadMessageId = getLastReadMessageId(lastReadMessage, action);

  return {
    ...state,
    [config.propName]: {
      ...state[config.propName],
      [action.payload.resourceId]: {
        ...currentResource,
        chats: {
          ...currentResourceChats,
          [action.payload.chatId]: {
            ...currentChat,
            lastReadMessageId,
            history: setChatHistoryLastReadMessage(
              currentHistory,
              lastReadMessageId
            ),
          },
        },
      },
    },
  };
};
